import React from "react";

const DiscountModal = ({
  isOpen,
  onClose,
  discountSettings,
  handleDiscountChange,
  updateDiscountSettings,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-gray-900 bg-opacity-50 p-4">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md overflow-hidden">
        <div className="bg-gray-50 px-6 py-4 border-b border-gray-200">
          <h3 className="text-xl font-semibold text-gray-800">Update Discounts</h3>
          <p className="text-sm text-gray-500 mt-1">
            Modify discount percentages based on page count.
          </p>
        </div>
        <div className="p-6 space-y-4">
          <div className="flex justify-between items-center bg-gray-100 p-3 rounded-md">
            <span className="text-gray-700 font-medium">Pages 10 - 50</span>
            <input
              type="number"
              value={discountSettings.discount10to50}
              onChange={(e) => handleDiscountChange("discount10to50", e.target.value)}
              className="w-20 px-3 py-2 border border-gray-300 rounded-md text-sm text-right focus:ring-2 focus:ring-blue-500"
            />
            <span className="text-gray-600">%</span>
          </div>
          <div className="flex justify-between items-center bg-gray-100 p-3 rounded-md">
            <span className="text-gray-700 font-medium">Pages 50+</span>
            <input
              type="number"
              value={discountSettings.discountAbove50}
              onChange={(e) => handleDiscountChange("discountAbove50", e.target.value)}
              className="w-20 px-3 py-2 border border-gray-300 rounded-md text-sm text-right focus:ring-2 focus:ring-blue-500"
            />
            <span className="text-gray-600">%</span>
          </div>
        </div>
        <div className="bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              updateDiscountSettings();
              onClose();
            }}
            className="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700"
          >
            Save Changes
          </button>
        </div>
      </div>
    </div>
  );
};

export default DiscountModal;
